var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29854 28.1232C7.86987 28.1232 7.52401 27.991 7.26096 27.7266C6.99791 27.4621 6.86639 27.1243 6.86639 26.713V23.9955C6.86639 23.5744 6.99791 23.2365 7.26096 22.9819C7.52401 22.7175 7.86987 22.5853 8.29854 22.5853H11.8789C12.3076 22.5853 12.6534 22.7175 12.9165 22.9819C13.1795 23.2365 13.3111 23.5744 13.3111 23.9955V26.713C13.3111 27.1243 13.1795 27.4621 12.9165 27.7266C12.6534 27.991 12.3076 28.1232 11.8789 28.1232H8.29854ZM2 17.0181V13.4045H37V17.0181H2ZM7.15866 33H31.8413C33.5073 33 34.7836 32.5544 35.6701 31.6633C36.5567 30.7819 37 29.5089 37 27.8441V12.1559C37 10.4911 36.5567 9.21808 35.6701 8.33672C34.7836 7.44557 33.5073 7 31.8413 7H7.15866C5.49269 7 4.21642 7.44557 3.32985 8.33672C2.44328 9.21808 2 10.4911 2 12.1559V27.8441C2 29.5089 2.44328 30.7819 3.32985 31.6633C4.21642 32.5544 5.49269 33 7.15866 33Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/_card.6cfca54a969963f7dc8f2ee0af76baf7.svg";
export { ForwardRef as ReactComponent };